import useAuth from '@app/auth/use-auth';
import useGeneratePdf from '@app/components/reports/hooks/use-generate-pdf';
import { useGetProductResult } from '@shared/api/hooks/pcf/products';
import DownloadLoader from '@shared/components/download-loader';
import { useQueryStates } from 'nuqs';
import { useParams } from 'react-router-dom';
import { ProductPdfContent } from './product-pdf-content';
import { ProductPdfBreakdownPages } from './product-pdf-breakdown-pages';
import { productPdfParsers } from './product-pdf-params';

export default function ProductPdfDownloadPage() {
  const { product_id } = useParams();
  const { user } = useAuth();
  const [{ breakdown: withBreakdown }] = useQueryStates(productPdfParsers);

  const { data: productResult, isLoading } = useGetProductResult(product_id!);

  const title = productResult
    ? `Product Carbon Assessment - ${productResult.name}${
        withBreakdown ? ' - full breakdown' : ''
      }`
    : undefined;

  const { contentRef, status } = useGeneratePdf(title, 'p');
  const organizationName = user?.organizationName ?? '';

  return (
    <>
      <DownloadLoader downloadStatus={isLoading ? 'idle' : status} />
      <div ref={contentRef} className="w-fit">
        {productResult && (
          <>
            <ProductPdfContent
              productResult={productResult}
              organizationName={organizationName}
              last={!withBreakdown}
            />
            {withBreakdown && (
              <ProductPdfBreakdownPages
                productResult={productResult}
                organizationName={organizationName}
              />
            )}
          </>
        )}
      </div>
    </>
  );
}
